import React from 'react'

import PropTypes from 'prop-types'

import InfoButton from '../buttons/InfoButton'
import fullstory from '../../../utils/constants/fullstory'

const renderCurrencyInput = ({ input, placeholder, label, id, tipContent }) => {
  return (
    <div className="form-group m-0">
      {label && <label>{label}</label>}
      <span className="pull-right" style={{ color: '#808080' }}>
        {tipContent && <InfoButton content={tipContent} />}
      </span>

      <div className="input-group mb-3" id={label}>
        <div className="input-group-prepend">
          <span className="input-group-text">$</span>
        </div>
        <input
          {...input}
          type="number"
          step="1000"
          className={`form-control ${fullstory.classNames.currencyInput}`}
          placeholder={placeholder}
          id={id}
          style={{ zIndex: 0 }}
        />
      </div>
    </div>
  )
}

renderCurrencyInput.propTypes = {
  input: PropTypes.any.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
}

renderCurrencyInput.defaultProps = {
  placeholder: '36000',
}

export default renderCurrencyInput



// WEBPACK FOOTER //
// ./src/components/ui/forms/renderCurrencyInput.js